import type { OrgBranding } from '@/types'

const profile = import.meta.env.VITE_APP_PROFILE || 'full'
if (!['full', 'waste'].includes(profile)) throw new Error(`Unknown app profile: ${profile}`)

export const isWasteOnly = profile === 'waste'
export const deploymentHome = isWasteOnly ? '/waste' : '/'

// Deployment visibility is an additional restriction, never an authorization grant.
export function isDeploymentPath(path: string) {
  if (!isWasteOnly) return true
  const pathname = path.split(/[?#]/)[0]
  return pathname === '/waste' || pathname.startsWith('/waste/')
}

// Explicit deployment branding wins over organization branding for this image.
export function deploymentBranding(branding: Partial<OrgBranding>): Partial<OrgBranding> {
  if (!isWasteOnly) return branding
  const logo = import.meta.env.VITE_BRAND_LOGO_URL?.trim() || '/reclaps-logo.png'
  return {
    ...branding,
    productName: import.meta.env.VITE_BRAND_NAME?.trim() || 'Reclaps',
    loginTitle: import.meta.env.VITE_BRAND_NAME?.trim() || 'Reclaps',
    loginSubtitle: 'Let’s green protect. Manage waste collections and recycling operations.',
    colors: { primary: '#008f68', primaryDark: '#34d399', sidebar: '#b2d5c6', sidebarText: '#24483e', accent: '#008000' },
    ...(logo ? { logoUrl: logo, loginLogoUrl: logo } : {}),
    faviconUrl: import.meta.env.VITE_BRAND_FAVICON_URL?.trim() || logo,
  }
}
